<div class="flex items-center justify-end mb-4" data-testid="branch-statistics-header">
  <app-pan-button-group data-testid="period-toggle">
    @if (showCustomPeriod()) {
      <app-pan-button color="info" [fill]="'filled'" [disabled]="true"> Custom </app-pan-button>
    }

    @for (option of periodOptions; track $index) {
      <app-pan-button
        color="info"
        [fill]="period() === option.value ? 'filled' : 'outline'"
        (click)="period.set(option.value)"
        [attr.data-testid]="'period-toggle-' + option.value"
      >
        {{ option.label }}
      </app-pan-button>
    }
  </app-pan-button-group>
</div>

<div class="w-full flex gap-2" data-testid="branch-statistics-cards">
  @let stats = statistics();

  <app-pan-stat-card class="flex-1" [value]="stats.total_cases.toString()" stat="Total Cases">
    <span morelink [class.text-success]="stats.cases_growth_pct < 0" [class.text-danger]="stats.cases_growth_pct > 0">
      {{ formatGrowth(stats.cases_growth_pct) }}
    </span>
  </app-pan-stat-card>

  <app-pan-stat-card class="flex-1" [value]="stats.total_incidents.toString()" stat="Total Incidents">
    <span morelink [class.text-success]="stats.incidents_growth_pct < 0" [class.text-danger]="stats.incidents_growth_pct > 0">
      {{ formatGrowth(stats.incidents_growth_pct) }}
    </span>
  </app-pan-stat-card>

  <app-pan-stat-card class="flex-1" [value]="stats.total_loss | currency" stat="Loss Detected">
    <span morelink [class.text-success]="stats.loss_growth_pct < 0" [class.text-danger]="stats.loss_growth_pct > 0">
      {{ formatGrowth(stats.loss_growth_pct) }}
    </span>
  </app-pan-stat-card>

  <app-pan-stat-card class="flex-1" [value]="stats.total_loss_represented | currency" stat="Total Loss Represented">
    <span morelink [class.text-success]="stats.loss_represented_growth_pct < 0" [class.text-danger]="stats.loss_represented_growth_pct > 0">
      {{ formatGrowth(stats.loss_represented_growth_pct) }}
    </span>
  </app-pan-stat-card>
</div>
